import useAppSelector from '@/hooks/useAppSelector'
import { selectIsAuthenticatedClient } from '@/redux/slices/session'

export function useIsAuthenticatedClient() {
  return useAppSelector(selectIsAuthenticatedClient)
}
